/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */

import { getCSPNonce } from '@nextcloud/auth'
import { generateFilePath } from '@nextcloud/router'
import { defineCustomElement, reactive } from 'vue'
import FilesSidebarTabApp from './FilesSidebarTabApp.vue'
import { createMemoryRouter } from './router/router.ts'
import store from './store/index.js'
import pinia from './stores/pinia.ts'
import { NextcloudGlobalsVuePlugin } from './utils/NextcloudGlobalsVuePlugin.js'

import './init.js'

// CSP config for webpack dynamic chunk loading
__webpack_nonce__ = getCSPNonce()

// Correct the root of the app for chunk loading
// OC.linkTo matches the apps folders
// OC.generateUrl ensure the index.php (or not)
// We do not want the index.php since we're loading files
__webpack_public_path__ = generateFilePath('spreed', '', 'js/')

const router = createMemoryRouter()

/**
 *
 */
function newTab() {
	return defineCustomElement(FilesSidebarTabApp, {
		shadowRoot: false,
		configureApp(app) {
			app
				.use(store)
				.use(pinia)
				.use(router)
				.use(NextcloudGlobalsVuePlugin)
		},
	})
}

if (!window.OCA.Talk) {
	window.OCA.Talk = reactive({})
}
Object.assign(window.OCA.Talk, {
	fileInfo: null,
	newTab,
	store,
})
